
/**
  ブランクページ（初期表示用）
*/
<template>
  <v-ons-page>
    <v-ons-toolbar  style="height:50px;">
        <div class="left">
           <v-ons-button modifier="quiet" @click="SetHistoryPageVisible(false)">
             <v-ons-icon icon="fa-times"></v-ons-icon> {{ localizeLabel("Common", "close")}}</v-ons-button>
        </div>
        <div class="center"><h1 class="page_header_title">{{ localizeLabel("Order", "label_order_history")}}</h1></div>
        <div class="right"> </div>
    </v-ons-toolbar>
      <div class="content" style="overflow: scroll; height:100vh; padding-bottom:240px;">
        <div class="table_wrapper">
          <table class="order_history" style="width:100%;">
            <thead>
              <tr>
                <th class="item_name">{{ localizeLabel("Order", "label_item_name")}}</th>
                <th class="order_count">{{ localizeLabel("Order", "label_order_count")}}</th>
                <th class="order_total">{{ localizeLabel("Order", "label_order_amount")}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in OrderHistory" :key="index">
                <td class="item_name">{{item.GoodsName}}</td>
                <td class="order_count">{{item.Count}}</td>
                <td class="order_total">¥{{item.TotalK | addComma}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="total_block">
          <p class="totla_label">{{ localizeLabel("Order", "label_total_amount")}}: ¥{{OrderTotal | addComma}}</p>
        </div>
         <br>
         <br>

         <div class="bottom_toolbar">
          <v-ons-button modifier="large" @click="openConfirmAction" class="btn-commit" style="margin: 6px 0">{{localizeLabel("Tabbar", "checkout")}}</v-ons-button>
        </div>
      </div>
  </v-ons-page>
</template>

<script>
import Toolbar from "../components/msToolbar";
import { mapGetters, mapActions } from "vuex";

export default {
  name: 'OrderHistoryPage',
  data() {
    return {
      actionSheetCallVisible:true,
    }
  },
  created: function() {
    
  },
  computed: {
    ...mapGetters([
      'HistoryPageVisible',
      'OrderHistory',
      'OrderTotal',
       "localizeLabel",
      ]),
  },
  methods: {
    ...mapActions([
      'SetHistoryPageVisible',
      'showMessage',
      'ShowErrorMessage',
      'GetOrderHistory',
      'StaffCall',

    ]),
    localeString(str){
      return str.toLocaleString()
    },
    handleCallStaff(method){
      var self=this
      self.actionSheetCallVisible=false

      this.StaffCall(method)
      .then(()=>{
        
        self.SetHistoryPageVisible(false)
        self.showMessage(self.$store.getters.localizeLabel("Tabbar", "staff_call_msg"))
      })
    },

    openConfirmAction(){
      //this.refresh=true
      var buttons=[]
      var button_count=0
      var self=this
      buttons.push({
          label: this.$store.getters.localizeLabel("Tabbar", "checkout"),
      })
      buttons.push({
          label: this.$store.getters.localizeLabel("Common", "cancel"),
          icon: 'md-close'
      })
      this.$ons.openActionSheet({
        title: this.$store.getters.localizeLabel("Tabbar", "checkout_confirm"),
        cancelable: true,
        buttons: buttons
      }).then(function (index) { 
        if(index==0){
          //お会計
          self.handleCallStaff(11)
          
        }else{
          //cancel
        }
        //console.log('index: ', index) 
      });
      
    },

  },
  components: {
    "ms-toolbar": Toolbar,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
@import "../assets/sass/base.scss";

.content{
  padding: 20px 0px 90px;
  //background-color: #111!important;
  background: $background-image-path!important;
  background-size: cover!important;
  color: $base-font-color;
}
ons-toolbar{
    //background: black;
    background: $header-bg;
    color: $header-font-color;
    border-bottom: 1px solid gray;
  ons-button{
    color: $header-font-color!important;
  }
}

.item_name{
  text-align: left;
  font-size: 14px;
}
h3{
  font-size: 16px;
}
.order_count,
.order_total{
  text-align: right;
}
.order_count{
  width: 50px;
}
.order_total{
  width: 100px;
}
.total_block{
  margin: 0px;
  padding: 0 5px;
  text-align: right;
  font-size: 18px;
  background-color: $list-header-color;
  color: $tab-font-color;
  //border-radius: 3px;
  
}
.table_wrapper{
  //padding: 10px;
  background-color: $list-header-color;
}
.order_history{
  border-collapse:collapse;
  border-spacing: 0;
}
th,td{
  box-sizing: border-box;
  font-size: 15px;
  padding: 10px 15px;
  color: $tab-font-color;
}
th{
  font-size: 14px;
  &.item_name{
    padding: 15px 15px;
  }
  &.order_count{
    padding: 15px 0;
  }
  &.order_total{
    padding: 15px 15px;
  }
}
td{
  color: #000;
  border-bottom: 1px dotted gray;
  background-color:white;
}
thead{
  border-bottom: 1px solid silver;
}
tr:last-child{
  td{
    border-bottom: 1px solid silver;
  }
}
.totla_label{
  //background-color: $base-color3;
  margin: 3px 0;
  padding: 5px;
  border-radius: 20px;
  display: inline-block;
  font-size: 18px;
  font-weight: bold;
}

.bottom_toolbar{
  background: $button-container-color;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  z-index: 100;
}

.btn-commit{
  color: $input-button-font-color;
  background-color:$button-color;
}

/****************************/
</style>



// WEBPACK FOOTER //
// src/pages/OrderHistoryPage.vue